import React from 'react';
import { ASSETS } from '../assets/assetMapping';

const imgLogoColorAlter1 = ASSETS.LOGO_COLOR_ALTER; // Using BIGVU logo as fallback

export default function LogoWhite() {
  return (
    <div className="relative w-[151px] h-[66px]" data-name="logo white" data-node-id="2392:2257">
      <img 
        src={imgLogoColorAlter1}
        alt="Logo"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[68px] w-[153px] object-contain"
        style={{ imageRendering: '-webkit-optimize-contrast' }}
        data-name="logo_COLOR_ALTER 1" 
        data-node-id="2392:2258"
      />
    </div>
  );
}
